const variations = [
	{
		name: 'default',
		isDefault: true,
		attributes: { icon: 'core/info' },
	},
];

export default variations;
